/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBellRingS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.164 2.986C4.504 3.096 3 3.821 3 6H1c0-3.42 2.496-4.763 3.836-4.986zM21 6c0-2.18-1.504-2.903-2.164-3.014l.328-1.972C20.504 1.237 23 2.579 23 6zm-9-4a7 7 0 0 0-7 7v2.036l-.005.136a9.095 9.095 0 0 1-.328 2.04c-.166.555-.392 1.023-.676 1.338-.258.286-.56.45-.991.45v2h18v-2c-.43 0-.733-.164-.991-.45-.284-.315-.51-.783-.676-1.337A9.1 9.1 0 0 1 19 11.036V9a7 7 0 0 0-7-7zM8.09 19.413c1.563 3.45 6.345 3.455 7.83-.02l-1.84-.786c-.78 1.829-3.303 1.893-4.17-.02z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBellRingS as BellRingS };
